export { ErrorContent, type Props as ErrorContentProps } from './ErrorContent';
